import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "d59fa0df-9b13-4cd1-a8df-40e1e4e1d5a7",
  publicId: "1",
  name: "Introduction and overview of acoustical simulation",
  difficulty: 1,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, principle02, task01, task02],
};

export default lesson;
